import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  const scrollTo = (e, id) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hem" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#FAFAFA]">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="max-w-2xl z-10"
          >
            <span className="block text-xs uppercase tracking-[0.2em] text-stone-500 mb-6">
              Personlig Träning & Hälsa
            </span>
            <h1 className="text-5xl md:text-7xl font-medium mb-8 font-serif leading-tight">
              Starkare med <br /> <span className="italic text-stone-600">Diana</span>
            </h1>
            <p className="text-lg md:text-xl text-stone-600 font-light leading-relaxed mb-10 max-w-lg">
              Jag hjälper dig att bygga styrka, öka energin och skapa hållbara vanor – utan snabba lösningar eller orimliga krav.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#tjanster"
                onClick={(e) => scrollTo(e, 'tjanster')}
                className="inline-flex items-center justify-center px-8 py-4 bg-stone-900 text-white text-xs uppercase tracking-widest hover:bg-stone-800 transition-colors duration-300"
              >
                Se mina tjänster
              </a>
              <a 
                href="#om"
                onClick={(e) => scrollTo(e, 'om')}
                className="inline-flex items-center justify-center px-8 py-4 border border-stone-300 text-stone-900 text-xs uppercase tracking-widest hover:border-stone-900 transition-colors duration-300"
              >
                Läs mer om mig
              </a>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="relative h-[600px] w-full hidden lg:block"
          >
            <div className="absolute inset-0 bg-stone-200 rounded-t-full overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?q=80&w=2070&auto=format&fit=crop" 
                alt="Kvinna som tränar för hälsa och styrka" 
                className="w-full h-full object-cover object-center opacity-90 mix-blend-multiply"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;